<template>
  <vxe-modal v-model="visible" :loading="generating" :title="$t('button.obtain')" type="confirm" width="60%" @confirm="confirm">
    <vxe-card>
      <template #header>
        <vxe-tip :content="acquiredQuantity" status="error" title="需索取数量"/>
        <vxe-tip :content="obtainedQuantity" status="success" title="已索取数量"/>
        <vxe-button-group size="small" style="margin-left: 8px" vertical>
          <vxe-button content="重新分配" icon="vxe-icon-undo" status="danger" @click.stop="reset"/>
          <vxe-button :loading="analysing" content="索取分析" icon="vxe-icon-search" status="primary" @click.stop="analyse"/>
        </vxe-button-group>
      </template>
      <vxe-form :data="detail" border size="medium" title-align="center" title-background title-bold>
        <vxe-form-item field="item.name" span="12" title="business.label.itemName"/>
        <vxe-form-item field="item.no" title="business.label.itemNo"/>
        <vxe-form-item :item-render="{name:'VxeSwitch',props:{disabled:true}}" field="item.scattered" title="business.label.scattered"/>
        <vxe-form-item field="pack.specification" span="12" title="business.label.specification"/>
        <vxe-form-item field="pack.uom" title="business.label.uom"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:packTypes,props:{readonly:true}}" field="packType" title="business.label.packType"/>
        <vxe-form-item field="pack.factor" title="business.label.factor"/>
        <vxe-form-item field="pack.innerFactor" title="business.label.innerFactor"/>
        <vxe-form-item field="lot.no" title="business.label.lot"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:packTypes,props:{readonly:true}}" field="inventoryState" title="business.label.inventoryState"/>
      </vxe-form>
    </vxe-card>
    <vxe-table ref="table" :data="inventories" :edit-config="{}" :loading="loading" keep-source @cell-dblclick="({row})=>dblclick(row, 'obtainedQuantity')">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot" width="150"/>
      <vxe-column field="batch.no" title="business.label.batch" width="150"/>
      <vxe-column field="location.no" title="business.label.location" width="120"/>
      <vxe-column field="inventory.availableOutboundQuantity" title="可索取数量" width="100"/>
      <vxe-column field="obtainedQuantity" title="已索取数量"/>
    </vxe-table>
  </vxe-modal>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { ShipmentDetail } from '@/api/dto/order/ShipmentOrder'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Lot } from '@/api/dto/common/Lot'
import { getEnums } from '@/utils/util'

export default {
  name: 'ObtainModal',
  props: {
    type: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      detail: {
        item: new Item(),
        pack: new Pack(),
        lot: new Lot(),
        inventoryState: null,
        packType: null
      },   // 原始行对象
      inventories: [], // 库存对象
      inventoryStates: [],
      packTypes: [],
      value: 1,
      dictionary: [],
      shipmentOrder: {},  //整个订单对象
      loading: false,
      generating: false,
      analysing: false,
      acquiredQuantity: 0,
      obtainedQuantity: 0
    }
  },
  created() {
    getEnums('InventoryState').then(result => {
      this.inventoryStates = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
    })
  },
  methods: {
    open(detail, orderId) {
      this.shipmentOrder = { id: orderId }
      this.visible = true
      this.detail = Object.assign({}, detail)
      this.acquiredQuantity = this.type === 'suspended' ? detail.lessnessQuantity : detail.plannedQuantity
      this.refresh(this.detail)
    },
    refresh(detail) {
      this.loading = true
      findAll('dispatchLocationInventoryFactory', { 'detail.id': detail.id }).then(res => {
        if (res.success) {
          this.inventories = res.result
          this.obtainedQuantity = this.inventories.map(inv => inv.obtainedQuantity).reduce((a, b) => a + b)
        }
      }).finally(() => this.loading = false)
    },
    dblclick(record, column) {
      const needQuantity = this.acquiredQuantity - this.obtainedQuantity // 需分配数量
      if (needQuantity > 0) {
        this.$nextTick(() => {
          const availableOutboundQuantity = record['inventory']['availableOutboundQuantity']
          if (availableOutboundQuantity > needQuantity) {
            record[column] = record[column] + needQuantity
            this.obtainedQuantity = this.obtainedQuantity + needQuantity
          } else if (availableOutboundQuantity <= needQuantity) {
            record[column] = record[column] + availableOutboundQuantity
            this.obtainedQuantity = this.obtainedQuantity + availableOutboundQuantity
          }
        })
      }
    },
    reset() {
      for (let i = 0; i < this.inventories.length; i++) {
        this.inventories[i].obtainedQuantity = 0
      }
      this.obtainedQuantity = 0
    },
    analyse() {
      this.analysing = true
      post(api.dispatchAnalyse, {}, { 'detail.id': this.detail.id }).then(res => {
        if (res.success) {
          this.$notification['success']({
            message: '分析结果',
            description: '库存可索取'
          })
        }
      }).finally(() => this.analysing = false)
    },
    confirm() {
      this.generating = true
      const details = []   //附加行
      const inventory = this.inventories.filter(a => a.obtainedQuantity > 0)
      for (let i = 0; i < inventory.length; i++) {
        const detail = new ShipmentDetail()
        detail.inventoryState = inventory[i].inventory.inventoryState
        detail.actualQuantity = inventory[i].obtainedQuantity
        detail.original = false
        detail.plannedQuantity = inventory[i].obtainedQuantity
        detail.batch = inventory[i].batch
        detail.item = inventory[i].item
        detail.lot = inventory[i].lot
        detail.pack = inventory[i].pack
        detail.sku = inventory[i].sku
        detail.location = inventory[i].location
        detail.container = inventory[i].container
        detail.serialNumber = inventory[i].serialNumber === null ? null : inventory[i].serialNumber
        detail.saleDetail = this.detail.saleDetail
        detail.packType = this.detail.packType
        details.push(detail)
      }
      this.detail.details = details
      post(api.dispatchGenerate, {}, this.detail).then(res => {
        if (res.success) {
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.generating = false)
    }
  }
}
</script>